import { useSetting } from "metabase/common/hooks";

const getOriginInfo = (origin: string) => {
  const url = new URL(origin);
  let subdomain = url.hostname.split(".")[0];
  if (subdomain === "%2A" || subdomain === "*") {
    subdomain = "*";
  }
  let domain = url.hostname.split(".").slice(1).join(".");
  if (domain === "") {
    domain = subdomain;
    subdomain = "";
  }
  return {
    protocol: url.protocol,
    subdomain: subdomain,
    domain: domain,
    port: url.port,
  };
};

export const useIsValidSidekickClientEmbedOrigin = () => {
  const originsString = useSetting("sidekick-client-origins");
  if (!originsString) {
    return false;
  }
  const validOrigins = originsString
    .split(" ")
    .map((origin) => getOriginInfo(origin));

  if (window.parent === window || validOrigins.length === 0) {
    return false;
  }

  const parentOrigin = getOriginInfo(window.parent.origin);
  return validOrigins.some((origin) => {
    return (
      origin.protocol === parentOrigin.protocol &&
      origin.domain === parentOrigin.domain &&
      (origin.subdomain === "*" ||
        origin.subdomain === parentOrigin.subdomain) &&
      origin.port === parentOrigin.port
    );
  });
};
